import React from 'react';
import { Container, Accordion } from 'react-bootstrap';
import './FaqSection.css';

const FaqSection = () => {
  const faqs = [
    {
     question: "كيف يمكنني الإعلان عن عقار للبيع أو للإيجار؟",
     answer: "بكل بساطة، قم بالتواصل معنا عبر الواتساب. سيتولى فريقنا المختص زيارة العقار لتصويره وتجهيز كافة التفاصيل، ومن ثم نقوم برفع البيانات على خوادمنا ونشر الإعلان فوراً، دون الحاجة منك لإنشاء حساب أو بذل أي مجهود."
    },
    {
      question: "كيف يمكنني التواصل مع صاحب العقار؟",
      answer: "بمجرد دخولك على صفحة العقار الذي أعجبك، ستجد زر 'واتساب' وزر 'اتصال'. بمجرد الضغط عليهما، سيتم تحويلك مباشرة للتحدث مع المعلن أو الاتصال به هاتفياً."
    },
    {
      question: "هل يمكنني طلب معاينة للعقار قبل الشراء؟",
      answer: "بالتأكيد، يمكنك التنسيق مع المعلن مباشرة عبر الواتساب لتحديد موعد مناسب لزيارة العقار ومعاينته على أرض الواقع."
    },
    {
      question: "ماذا أفعل إذا لم أجد العقار الذي أبحث عنه؟",
      answer: "يمكنك التواصل معنا عبر الواتساب وإخبارنا بمواصفات العقار المطلوبة، وسيقوم فريقنا بتزويدك بأحدث العروض التي تناسب طلبك فور توفرها."
    },
    {
      question: "هل جميع العقارات المعروضة للبيع فقط؟",
      answer: "لا، منصة بيتي توفر حالياً خيارات متنوعة تشمل العقارات المعروضة للبيع وللإيجار (بيوت، شقق، وأراضي)، لتلبي كافة احتياجاتكم السكنية والاستثمارية."
    }
  ];

  return (
    <section className="faq-section" id="faq" dir="rtl">
      <Container>
        <div className="section-header text-end mb-5">
          <h2 className="main-title fw-bold mt-2">الأسئلة الشائعة</h2>
          <p className="text-muted">هل لديك أسئلة؟ لدينا الإجابات! تصفح قسم الأسئلة الشائعة للعثور على حلول سريعة للأسئلة الشائعة حول بيتي.</p>
        </div>

        {/* قائمة الأسئلة */}
        <div className="faq-list-wrapper">
          <Accordion flush>
            {faqs.map((faq, index) => (
              <Accordion.Item eventKey={index.toString()} key={index} className="faq-custom-item">
                <Accordion.Header className="faq-q-text">{faq.question}</Accordion.Header>
                <Accordion.Body className="faq-a-text text-muted">
                  {faq.answer}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </Container>
    </section>
  );
};

export default FaqSection;